<template>
  <div class="content">
    <div class="nav " :class=" {nav_top:scrollTop}">
      <div class="logo_box">
        <img src="../assets/logo.png" alt="" v-if="!scrollTop">
        <img src="../assets/LOGO_hei.png" v-else alt="">
      </div>
      <div class="nav_content">
        <ul>
          <li class="item " @click="goTo('Home')"><span >HOME</span></li>
          <li class="item ours " v-if="lang=='en'">
            <span class="navActive">OUR PRODUCTS</span>
            <div class="our">
              <div class="items " @click="goTo('Bodys')" ><span >BODY LOTION</span></div>
              <div class="items" @click="goTo('Sham')"><span class="ourActive">SHAMPOO</span></div>
              <div class="items" @click="goTo('Bath')"><span> BATH & SHOWER GEL</span></div>
            </div>
          </li>
          <li class="item ours " v-if="lang=='it'">
            <span class="navActive">NOSTRI PRODOTTI</span>
            <div class="our">
              <div class="items " @click="goTo('Bodys')" ><span >CREMA CORPO</span></div>
              <div class="items" @click="goTo('Sham')"><span class="ourActive">SHAMPOO</span></div>
              <div class="items" @click="goTo('Bath')"><span> BAGNO DOCCIA</span></div>
            </div>
          </li>
          <li class="item" @click="goTo('Story')" v-if="lang=='en'"><span>STORY & HISTORY</span></li>
          <li class="item" @click="goTo('Story')"  v-if="lang=='it'"><span>STORIA</span></li>
          <li class="item" @click="goTo('Contact')" v-if="lang=='en'"><span >CONTACT US</span></li>
          <li class="item" @click="goTo('Contact')" v-if="lang=='it'"><span >CONTATTACI</span></li>
        </ul>
      </div>
      <div class="phone-nav-content" v-if="modelStatus" @click="toggleModel">
        <ul v-if="!twoBoxStatus">
          <li class="item " @click="goTo('Home')">HOME</li>
          <li class="item active right-arrow" @click.stop="twoBox">OUR PRODCTS</li>
          <li class="item" @click="goTo('Story')">{{lang=='en'?'STORY & HISTORY':'STORIA'}}</li>
          <li class="item" @click="goTo('Contact')">  {{lang=='en'?'CONTACT US':'CONTATTACI'}}</li>
          <li class="langp" @click="langFn">
            <span :class="{langActive:lang=='en'}">EN</span>/<span class="IT" :class="{langActive:lang!='en'}">IT</span>
          </li>
        </ul>
        <div class="titleBack " v-if="twoBoxStatus" @click.stop="goBack">
          <div class="back" style="width: 0.32rem;height: .32rem">
            <img style="width: 100%;height: 100%" src="../assets/back.png" alt="">
          </div>
         <div class="titleText" style="font-size: 1rem;color: #231815;margin-top: .5rem" v-if="lang=='en'">
            <p>OUR</p>
            <p>PRODUCTS</p>
          </div> <div class="titleText" style="font-size: 1rem;color: #231815;margin-top: .5rem" v-if="lang=='it'">
            <p>NOSTRI</p>
            <p>PRODOTTI</p>
          </div>
        </div>
        <ul class="two" v-if="twoBoxStatus">
          <li class="item" @click="goTo('Bodys')">{{lang=='en'?'BODY LOTION':'CREMA CORPO'}}</li>
          <li class="item active" @click="goTo('Sham')">SHAMPOO</li>
          <li class="item" @click="goTo('Bath')">{{lang=='en'?'BATH & SHOWER GEL':'BAGNO DOCCIA'}}</li>
        </ul>
      </div>
      <div class="click_box" @click="toggleModel">
        <div class="top_flag"></div>
        <div class="bottom_flag"></div>
      </div>
      <div class="lang"  :class=" {lang_top:scrollTop}" @click="langFn">
        <span :class="{langActive:lang=='en'}">EN</span>/<span class="IT" :class="{langActive:lang!='en'}">IT</span>
      </div>
    </div>
    <div class="main_content">
      <div class="banner_box" >
      </div>
      <div class="iphone_raff main_item" v-for="item in productsList.list"  @click="goDetailWap(item.data,item.type)" >
        <div class="message_text">
          <div class="raff_flag"></div>
          <div class="text_title">
            <p>{{item.name}}</p>
            <p>{{item.names}}</p>
          </div>
          <div class="text_content">
            Beginning with plant science and aesthetics,
            botanist Raffaella Nannoni has …
          </div>
          <div class="more" style="text-align: left">MORE</div>
        </div>
        <div class="raff_image" :style="{backgroundImage:'url('+item.imgUrl+')'}"></div>
      </div>
      <div class="products_box main_item">
        <div class="body_lotion" @click="goDetail('sham','ROSEMARY')">
          <div class="message_title">
            <p v-if="lang=='en'">ROSEMARY</p>
            <p v-if="lang=='it'">AL ROSMARINO</p>
            <p>SHAMPOO </p>
            <p class="more">MORE</p>
          </div>
          <div class="body_img">
          </div>
        </div>
        <div class="orangeCitrus">
          <div class="orange"  @click="goDetail('sham','NETTLE')" >
            <div class="orange_img"></div>
            <div class="orange_title">
              <P v-if="lang=='en'">NETTLE</P>
              <p v-if="lang=='it'">ALL’ORTICA</p>
              <p>SHAMPOO </p>
              <p class="more">MORE</p>
            </div>
          </div>
          <div class="citrus"  @click="goDetail('sham','PEACH')">
            <div class="citrus_img"></div>
            <div class="citrus_title">
              <P v-if="lang=='en'">PEACH</P>
              <P v-if="lang=='it'">ALLA PESCA</P>
              <p>SHAMPOO </p>
              <p class="more">MORE</p>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="tan"  @click="goDetail('sham','SAGE')">
          <div class="message_title">
            <div class="title_box">
              <p v-if="lang=='en'">SAGE AND ARTICHOKE</p>
              <p v-if="lang=='it'">SALVIA E CARCIOFO</p>
              <p>SHAMPOO</p>
              <p class="more" style="float: right">MORE</p>
            </div>
          </div>
          <div class="tan_img"></div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="phone_products_box"></div>
    </div>
    <myFooter></myFooter>
  </div>
</template>
<style scoped lang="scss">
  .content {
    width: 100%;
    position: relative;
    .clear {
      clear: both;
    }
    .more{
      font-family: Konnect-Regular;;
    }
    .nav {
      width: 100%;
     height:80px;
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      justify-content: space-around;
      align-items: center;
      box-sizing: border-box;
      margin: 0 auto;
      z-index: 1;
      font-family: CantoriaMT;
      background-color: #000000;

      .logo_box {
        height: 53px;
        width: 60px;
      }

      .nav_content {
       height:80px;
        box-sizing: border-box;
        .item {
          display: inline-block;

          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #666666;
          margin-right: 78px;
          line-height: 80px;
          position: relative;
          .our{
            position: absolute;
            top: 80px;
            left: -80px;
            width: 260px;
            height: 191px;
            background-color: #ffffff;
            box-shadow: 0px 4px 8px 0px
            rgba(0, 0, 0, 0.06);
            color: #999999;
            box-sizing: border-box;
            font-size: 14px;
            padding: 40px 43px 0;
            display: none;
            div{
              display: block;
              /*margin-bottom: 30px;*/
              height: 50px;
              line-height: 0px;
            }
            .ourActive{

              border-bottom: 1px solid #231815;
              color: #231815;
            }

          }

        }

        .navActive{
          color: #ffffff;
          border-bottom: 1px solid #FFFFFF;
        }
        .ours:hover .our{
          display: block;
        }
      }
      .lang{
        color:#666666;
        .langActive{
          color: #ffffff;
        }
      }
      .lang_top{
        color:#999999;
        .langActive{
          color: #000;
        }
      }
      .click_box {
        display: none;
        height: 30px;
        width: 30px;
        div {
          border-bottom: 1px solid #FFF;
          width: 30px;
          margin-top: 10px;
        }
      }
    }
    .nav_top {
      height: 80px;
      background-color: #ffffff;
      line-height: 80px;

      .nav_content {
        line-height: 80px;
        .item {
          /*line-height: 80px;*/
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #999999;
          .our{
            top: 70px;
          }
        }
        .navActive {
          border-bottom: 1px solid #231815;
          color: #231815;
        }

      }


    }
    .banner_box {
      position: relative;
      width: 100%;
      height: 400px;
      background: url("../assets/banner-2.png") no-repeat center;
      background-size: cover;
      overflow: hidden;
      display: none;
    }
    .main_content {
      .main_item {
        width: 1200px;
        margin: 0 auto;
        /*display: none;*/
      }

      .story_box {
        margin-top: 160px;
        height: 561px;
        .message_text {
          float: left;
          width: 410px;
          height: 100%;
          position: relative;

          .story_flag {
            width: 18px;
            height: 3px;
            background-color: #231815;
          }

          .text_title {
            margin-top: 283px;
            width: 240px;
            height: 101px;

            font-size: 50px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #231815;
          }

          .text_content {
            width: 308px;
            height: 95px;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #9b9b9b;
          }

          .more {
            width: 70px;
            height: 21px;
            background-color: #231815;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #ffffff;
            text-align: center;
            line-height: 21px;
            position: absolute;
            left: 0;
            bottom: 0;
          }
        }

        .story_image {
          float: left;
          width: 790px;
          height: 100%;
          background: url('../assets/story.png') no-repeat center;
        }
      }

      .raff_box {
        padding: 100px 0;
        height: 790px;
        .message_text {
          float: left;
          height: 790px;
          position: relative;
          text-align: right;
          padding-left: 226px;

          .story_flag {
            width: 18px;
            height: 3px;
            background-color: #231815;
          }

          .text_title {
            margin-top: 302px;
            width: 354px;
            height: 150px;

            font-size: 50px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #231815;
          }

          .text_content {
            width: 354px;
            height: 94px;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #9b9b9b;
          }

          .more {
            width: 70px;
            height: 21px;
            background-color: #231815;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #ffffff;
            text-align: center;
            line-height: 21px;
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }

        .raff_image {
          float: left;
          width: 620px;
          height: 790px;
          background: url('../assets/raff.png') no-repeat center;
        }
      }

      .iphone_raff {
        display: none;
      }

      .products_box {
        font-family: Konnect-Regular;
        .tab_list {
          height: 50px;
          display: flex;
          justify-content: space-between;
          .title_text {
            width: 295px;
            height: 50px;

            font-size: 50px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #231815;
          }
          .list_item{
            width: 495px;
            height: 20px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #999999;
            display: flex;
            justify-content: space-between;
            li{
              display: inline-block;
            }
            .active{
              background-color: #231815;
              padding: 0 10px;
              line-height: 20px;
            }

          }
        }
        .body_lotion{
          height: 560px;
          margin-top: 130px;
          .message_title{
            width: 410px;
            float: left;
            padding-top: 357px;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #231815;
            font-family: Konnect-Bold;

            .more{
              font-size: 14px;
              margin-top: 134px;
              font-family: Konnect-Regular;
            }
          }
          .body_img{
            float: left;
            width: 790px;
            height: 100%;
            background: url('../assets/sham-1.png') no-repeat center;
            background-size: cover;
          }
        }
        .orangeCitrus{
          margin-top: 160px;
          font-size: 20px;
          position: relative;
          height: 860px;
          .orange{
            width: 790px;
            height: 560px;
            float: left;
            .orange_img{
              float: left;
              width: 380px;
              height: 560px;
              background: url('../assets/sham-2.png') no-repeat center;
              background-size: cover;
            }
            .orange_title{
              float: left;
              width: 277px;
              padding-left: 133px;
              font-family: Konnect-Bold;
              .more{
                font-size: 14px;
                margin-top: 134px;
                font-family: Konnect-Regular;
              }
            }
          }
          .citrus{
            width: 790px;
            height: 560px;
            float: right;
            position: absolute;
            top: 280px;
            right: 0;
            .citrus_img{
              float: right;
              width: 380px;
              height: 560px;
              background: url('../assets/sham-3.png') no-repeat center;
              background-size: cover;
            }
            .citrus_title{
              float: left;
              width: 277px;
              position: absolute;
              bottom: 0;
              padding-left: 100px;
              font-family: Konnect-Bold;
              .more{
                font-size: 14px;
                margin-top: 134px;
                font-family: Konnect-Regular;
              }
            }
          }
          .orange:hover{
            .orange_title{
              .more{
                background-color: black;
                color: #ffff;
                font-family: Konnect-Bold;
                width: 70px;
                height: 20px;
                text-align: center;
                line-height: 20px;
              }
            }
          }
          .citrus:hover{
            .citrus_title{
              .more{
                background-color: black;
                color: #ffff;
                font-family: Konnect-Bold;
                width: 70px;
                height: 20px;
                text-align: center;
                line-height: 20px;
              }
            }
          }
        }
        .tan{
          height: 560px;
          margin-top: 140px;

          .message_title{
            position: relative;
            width: 410px;
            height: 100%;
            float: right;
            text-align: right;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #231815;
            font-family: Konnect-Bold;
            .title_box{
              position: absolute;
              right: 0;
              bottom: 0;
              .more{
                font-size: 14px;
                margin-top: 140px;
                width: 70px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                font-family: Konnect-Regular;
              }
            }

          }
          .tan_img{
            float: left;
            width: 790px;
            height: 100%;
            background: url('../assets/sham-4.png') no-repeat center;
            background-size: cover;
          }
        }
        .body_lotion:hover{
          .message_title{
            .more{
              background-color: black;
              color: #ffff;
              font-family: Konnect-Bold;
              width: 70px;
              height: 20px;
              text-align: center;
              line-height: 20px;
            }
          }
        }
        .tan:hover{
          .message_title{
            .title_box{
              .more{
                background-color: black;
                color: #ffff;
                font-family: Konnect-Bold;
                width: 70px;
                height: 20px;
                text-align: center;
                line-height: 20px;
              }
            }
          }
        }
      }

    }
  }

  @media screen and (max-width: 900) {
    .content {
      width: 100%;
      position: absolute;
      .text_title{
        font-family: Konnect-Bold;
      }
      .more{
        font-family: Konnect-Regular;
        background: url("../assets/arrow.png") no-repeat  100% 45%;
        background-size: .12rem .05rem;
      }
      .nav {
        width: 100%;
        height: 0.88rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 0 .3rem;
        align-items: center;
        box-sizing: border-box;
        font-family: CantoriaMT;
        .logo_box {
          height: 0.53rem;
          width: 0.6rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .nav_content {
          display: none;

          .item {
            display: inline-block;
            font-size: 0.14rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #666666;
            margin-right: 78px;
          }
        }

        .phone-nav-content {
          display: block;
          background-color: #fff;
          position: fixed;
          left: 0;
          right: 0;
          top: 0.88rem;
          bottom: 0;
          padding: 0.78rem 0.4rem;

          ul {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            animation: mymove 1s;
            position: absolute;
            top: 0.78rem;
            padding-left: 0.4rem;
            @keyframes mymove {
              from {
                left: 0;
              }
              to {
                left: .4rem;
              }
            }

            @-webkit-keyframes mymove /*Safari and Chrome*/
            {
              from {
                left: 0;
              }
              to {
                left: .4rem;
              }
            }

            .item {
              height: .36rem;
              font-size: .40rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #999999;
              margin-top: 1.2rem;   line-height: 0.36rem;
            }
            .right-arrow{
              background: url("../assets/right-arrow.png") no-repeat center right;
              background-size: .32rem .32rem;
              width: 4.5rem;
            }
            .back {

            }

            .active {
              border-bottom: 0.01rem solid #999999;
            }
          }

          ul.two {
            top: 4.75rem;
            padding-left: 0;

            .item {
              font-size: .32rem;
              margin-top: 0.6rem;

            }
          }
        }

        .click_box {
          height: 0.32rem;
          width: 0.32rem;
          display: block;

          div {
            border-bottom: 0.02rem solid #FFF;
            width: 0.32rem;
            margin-top: 0.1rem;
          }
        }
        .langp {
          font-size: .3rem;
          color: #999999;
          margin-top: .4rem;

          .langActive {
            color: black;
            font-weight: bold;
          }
        }
      }

      .nav.nav_top {
        background-image: none;
        background-color: #fff;

        .click_box {
          div {
            border-bottom: 0.02rem solid black;
          }
        }
      }

      .lang{
        display: none;
      }
      .main_content {
        .main_item {
          width: 6.9rem;
          margin: 0 auto;
          display: block;
          padding: 0 0.3rem;
        }

        .story_box {
          margin-top: 1.2rem;
          display: none;
          .message_text {
            float: none;
            width: 6.9rem;
            height: 5.64rem;
            position: relative;
            padding-bottom: .78rem;

            .story_flag {
              width: 0.2rem;
              height: 0.02rem;
              background-color: #231815;
            }

            .text_title {
              margin-top: 2.8rem;
              width: 2.4rem;
              height: 1rem;

              font-size: .5rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 0.5rem;
              letter-spacing: 0px;
              color: #231815;
            }

            .text_content {
              width: 308px;
              height: 95px;

              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 0px;
              color: #9b9b9b;
            }

            .more {
              width: 0.9rem;
              height: 0.21rem;
              background-color: #231815;

              font-size: 0.14rem;
              font-weight: normal;
              font-stretch: normal;
              color: #ffffff;
              text-align: center;
              line-height: 0.21rem;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }

          .story_image {
            float: none;
            width: 6.9rem;
            height: 4.8rem;
            background: url('../assets/story.png') no-repeat center;
            background-size: cover;
            margin-top: 0.6rem;
          }
        }

        .raff_box {
          display: none;
          padding: 1rem 0;

          .message_text {
            float: none;
            position: relative;
            text-align: right;

            .story_flag {
              width: 0.2rem;
              height: 0.01px;
              background-color: #231815;
            }

            .text_title {
              margin-top: 0.3rem;
              width: 0.354rem;
              height: 150px;

              font-size: 50px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 50px;
              letter-spacing: 0px;
              color: #231815;
            }

            .text_content {
              width: 354px;
              height: 94px;

              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 0px;
              color: #9b9b9b;
            }

            .more {
              width: 70px;
              height: 21px;
              background-color: #231815;

              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 1px;
              color: #ffffff;
              text-align: center;
              line-height: 21px;
              position: absolute;
              right: 0;
              bottom: 0;
            }
          }

          .raff_image {
            float: none;
            width: 620px;
            height: 790px;
            background: url('../assets/raff.png') no-repeat center;
          }
        }

        .iphone_raff {
          display: block;

          .message_text {
            width: 100%;

            .raff_flag {
              width: 0.2rem;
              height: 0.02rem;
              margin-top: 1.2rem;
              background-color: #231815;
            }

            .text_title {
              margin-top: 1.42rem;
              height: .8rem;

              font-size: 0.34rem;
              font-weight: normal;
              font-stretch: normal;
              line-height: 0.50rem;
              letter-spacing: 0px;
              color: #231815;
            }

            .text_content {
              display: none;
              width: 3.45rem;
              height: 0.94rem;
              font-size: 0.24rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #9b9b9b;
              margin-top: .2rem;
            }

            .more {
              width: 0.9rem;
              height: .2rem;
              /*background-color: #231815;*/
              line-height: .2rem;

              text-align: center;
              font-size: .20rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #9b9b9b;
              margin-top: .3rem;
            }
          }

          .raff_image {
            float: none;
            width: 6.9rem;
            height: 8.2rem;
            background: url('../assets/raff.png') no-repeat center;
            background-size: cover;
            margin-top: .6rem;
          }
        }
        .products_box{
          display: none;
        }
        .phone_products_box{

        }
      }
    }


  }

</style>
<script>
  export default {
    name: 'HelloWorld',
    data() {
      return {
        scrollTop: 0,
        windowWidth: null,
        modelStatus: false,
        pcModelStatus: false,
        curIndex: 0,
        productsList:
          {
            name: "SHAMPOO",
            list: [
              {
                name: "ROSEMARY",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_551ddfak0a8bbali53jd13d0il3jj_620x430.png',
                type:"ROSEMARY",
                data:'sham'
              },
              {
                name: "NETTLE",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_0128gkj06jj1032d49c84j3c855gd_620x430.png',
                type:"NETTLE",
                data:'sham'

              },
              {
                name: "PEACH",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aiiad3a5gda825ebahd17flg0c02_620x430.png',
                type:"PEACH",
                data:'sham'
              },
              {
                name: "SAGE AND ARTICHOKE",
                names: 'SHAMPOO',
                imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aca6903gidf8aiia1fc78360kj16_620x430.png',
                type:"SAGE",
                data:'sham'
              },
            ],
          },
        list: [
          {
            name: "ROSEMARY",
            names: 'SHAMPOO',
            imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_551ddfak0a8bbali53jd13d0il3jj_620x430.png',
            type:"ROSEMARY",
            data:'sham'
          },
          {
            name: "NETTLE",
            names: 'SHAMPOO',
            imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_0128gkj06jj1032d49c84j3c855gd_620x430.png',
            type:"NETTLE",
            data:'sham'

          },
          {
            name: "PEACH",
            names: 'SHAMPOO',
            imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aiiad3a5gda825ebahd17flg0c02_620x430.png',
            type:"PEACH",
            data:'sham'
          },
          {
            name: "SAGE AND ARTICHOKE",
            names: 'SHAMPOO',
            imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aca6903gidf8aiia1fc78360kj16_620x430.png',
            type:"SAGE",
            data:'sham'
          },
        ],
        yiList: [
          {
            name: 'SHAMPOO',
            names: "AL ROSMARINO",
            imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_551ddfak0a8bbali53jd13d0il3jj_620x430.png',
            type:"ROSEMARY",
            data:'sham'
          },
          {
            name: 'SHAMPOO',
            names: "ALL’ORTICA",
            imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_0128gkj06jj1032d49c84j3c855gd_620x430.png',
            type:"NETTLE",
            data:'sham'

          },
          {
            name: 'SHAMPOO',
            names: "ALLA PESCA",
            imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aiiad3a5gda825ebahd17flg0c02_620x430.png',
            type:"PEACH",
            data:'sham'
          },
          {
            name: 'SHAMPOO',
            name: "SALVIA E CARCIOFO",
            imgUrl: 'https://s10.mogucdn.com/mlcdn/c45406/190324_3aca6903gidf8aiia1fc78360kj16_620x430.png',
            type:"SAGE",
            data:'sham'
          },
        ],
        twoBoxStatus: false,
        productType:'',
        lang:''
      }
    },
    mounted() {
      console.log(this.$route.query.type)
      this.productType=this.$route.query.type;
      this.lang=this.defined.lang
      this.windowWidth = window.document.documentElement.clientWidth;
      window.addEventListener('scroll', () => {
        const cHeight = document.getElementsByClassName('banner_box')[0].clientHeight
        if (document.documentElement.scrollTop !=0) {
          this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        } else {
          this.scrollTop = 0;
        }


      })
    },
    methods: {
      goTo(data, type) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        if(this.productType&&type){
          this.productType=type;
        }else {
          this.$router.push({path: `/${data}`, query: {type: type}})
        }

      },
      toggleModel() {
        if (this.windowWidth <= 1024 && !this.modelStatus) {
          this.modelStatus = true
          this.twoBoxStatus = false
        } else if (this.windowWidth <= 1024 && this.modelStatus) {
          this.modelStatus = false
          this.twoBoxStatus = false
        } else if (this.windowWidth > 1024 && !this.pcModelStatus) {
          this.pcModelStatus = true;
        } else if (this.windowWidth > 1024 && this.pcModelStatus) {
          this.pcModelStatus = false;
        }
      },
      toggleList(index) {
        this.curIndex = index
      },
      twoBox() {
        this.twoBoxStatus = true;
      },
      goBack() {
        this.twoBoxStatus = false;
      },
      goDetail(data,type){
        console.log(1)
        this.$router.push({path: `/Detail`,query:{data,type}})
      },
      langFn(){
        if(this.defined.lang=='en'){
          this.defined.setLang('it')
          this.lang='it'
          this.productsList.list=this.yiList
        }else {
          this.defined.setLang('en')
          this.lang='en'
          this.productsList.list=this.list
        }
      },
      goDetailWap(data,type){
        console.log(data)
        console.log(type)
        this.$router.push({path: `/Detail`,query:{data,type,wap:'wap'}})
      }

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/Shampoo.vue